import Vue from 'vue'
import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration } from '@sentry/integrations'

export default {
  init() {
    Sentry.init({
      dsn:
        'https://e641fd7b89fe4c8397c94d9c4d8bbe56@o261284.ingest.sentry.io/5269756',
      integrations: [new VueIntegration({ Vue, attachProps: true })]
    })
  }
}
